import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getGooglePlace } from "../functions/getGooglePlace";
import lang from "../functions/lang";
import { Store } from "../interfaces/IStore";

const TD = styled.td`
  border-bottom: none;
`;

export const useGoogle = (store: Store | undefined) => {
  const [starRating, setStarRating] = useState<number>();
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [storeHours, setStoreHours] = useState<{ [key: string]: any }[]>([]);
  const [storeAddress, setStoreAddress] = useState<string[]>();
  const [storeUrl, setStoreUrl] = useState<string>();
  const [googleDirectionsAPI, setGoogleDirectionsAPI] = useState<string>();
  const [googleData, setGoogleData] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    setLoading(true);
    if(store?.google_id && store.business_type !== "airbnb") {
      getGooglePlace({ id: store.google_id }).then((data) => {
        setGoogleData(data);
        setLoading(false);
      });
    } else {
      setGoogleData(undefined);
    }
  }, [store]);

  useEffect(() => {
    store?.url && setStoreUrl(store.url);
    // First need to check to see if airbnb data is undefined.
    if (store?.google_id) {
      getGoogleInfo(store.google_id);
    } else {
      setStarRating(0);
      setPhoneNumber(undefined);
      setStoreHours([]);
      setStoreAddress(undefined);
      setStoreUrl(undefined);
      setGoogleDirectionsAPI(undefined);
    }
  }, [googleData]);

  const getGoogleInfo = (id: string) => {
    setGoogleDirectionsAPI(
      `https://www.google.com/maps/dir/${store?.latitude}, ${store?.longitude}?hl=${window.data?.language}`
    );
    setStarRating(store?.rating_override || googleData?.rating);
    setPhoneNumber(googleData?.formatted_phone_number);
    setStoreAddress(googleData?.formatted_address.trim()); //googleData.formatted_address.split(",").map((a:string) => a.trim())
    const hours =
      googleData?.opening_hours?.periods.map((p: any) => {
        let day: string = "";
        switch (p?.open?.day) {
          case 0:
            day = lang(
              "storeCard.weekdays.sunday",
              window.data?.language || "en"
            );
            break;
          case 1:
            day = lang(
              "storeCard.weekdays.monday",
              window.data?.language || "en"
            );
            break;
          case 2:
            day = lang(
              "storeCard.weekdays.tuesday",
              window.data?.language || "en"
            );
            break;
          case 3:
            day = lang(
              "storeCard.weekdays.wednesday",
              window.data?.language || "en"
            );
            break;
          case 4:
            day = lang(
              "storeCard.weekdays.thursday",
              window.data?.language || "en"
            );
            break;
          case 5:
            day = lang(
              "storeCard.weekdays.friday",
              window.data?.language || "en"
            );
            break;
          case 6:
            day = lang(
              "storeCard.weekdays.saturday",
              window.data?.language || "en"
            );
            break;
        }
        const hoursSep = window.data?.language === "fr"?"h":":";
        const open_en = Number(p?.open?.time?.slice(0, 2))>=12?`${Number(p?.open?.time?.slice(0, 2))-12}`:`${p?.open?.time?.slice(0, 2)}`;
        const open_fr = p?.open?.time?.slice(0, 2);
        const open_ampm = window.data?.language === "fr"?"":Number(p?.open?.time?.slice(0, 2))>=12?"pm":"am"
        const close_en = p?.close?.time?.slice(0, 2)>=12?`${p?.close?.time?.slice(0, 2)-12}`:`${p?.close?.time?.slice(0, 2)-12}`;
        const close_fr = p?.close?.time?.slice(0, 2);
        const close_ampm = window.data?.language === "fr"?"":Number(p?.close?.time?.slice(0, 2))>=12?"pm":"am"
        const open = window.data?.language === "fr"?open_fr:open_en;
        const close = window.data?.language === "fr"?close_fr:close_en;
        return p?.open?.time && p?.close?.time ? (
          <tr key={day}>
            <TD key="day">{day}</TD>
            <TD key="open">
              {open}{hoursSep}{p?.open?.time?.slice(2)}{open_ampm}
            </TD>
            <TD key="close">
              {close}{hoursSep}{p?.close?.time?.slice(2)}{close_ampm}
            </TD>
          </tr>
        ) : null;
      }) || [];
    setStoreHours(hours);
    !storeUrl && setStoreUrl(googleData?.website || undefined);
  };

  return {
    starRating,
    phoneNumber,
    storeHours,
    storeAddress,
    googleDirectionsAPI,
    storeUrl,
    loading,
  };
};
